module.exports = __webpack_public_path__ + "static/media/priyanshagarwal.d939c93c.jpg";